import * as React from 'react'
import { Combobox } from '@base-ui/react/combobox'
import type { PartProps } from '../../../lib/part-props'

type ComboboxValueProps = PartProps<React.ComponentProps<typeof Combobox.Value>>

function ComboboxValue({ children, ...props }: ComboboxValueProps) {
  return <Combobox.Value {...props}>{children}</Combobox.Value>
}

export { ComboboxValue }
